import { PUBLIC_MAX_MIN_ORDER_QTY } from '@repo/api-contracts';
import { type ReactElement, useEffect, useId, useState } from 'react';
import { Input } from '@/shared/ui';

interface MinOrderQtyFilterProps {
  readonly value: number | undefined;
  readonly onChange: (value: number | undefined) => void;
}

/** "N개 이하로 만들 수 있는 상품" 상한 입력 — blur/Enter 에 확정한다. */
export const MinOrderQtyFilter = ({ value, onChange }: MinOrderQtyFilterProps): ReactElement => {
  const [draft, setDraft] = useState(value?.toString() ?? '');
  // 패널이 화면에 둘 이상 서도 겹치지 않게 id 를 고정하지 않는다.
  const inputId = useId();

  // URL(단일 원천)이 바뀌면 입력값을 따라간다.
  useEffect(() => {
    setDraft(value?.toString() ?? '');
  }, [value]);

  const commit = (): void => {
    const parsed = Number(draft);
    const next =
      Number.isInteger(parsed) && parsed >= 1 && parsed <= PUBLIC_MAX_MIN_ORDER_QTY
        ? parsed
        : undefined;

    // 무효 입력은 표시도 함께 정리한다 — 적용된 것처럼 입력창에 남지 않게.
    setDraft(next?.toString() ?? '');

    // 값이 그대로면 커밋하지 않는다 — blur 마다 동일 URL 을 히스토리에 쌓지 않게.
    if (next !== value) {
      onChange(next);
    }
  };

  return (
    <div className="space-y-2">
      <label htmlFor={inputId} className="sr-only">
        최소 주문 수량 상한
      </label>
      <Input
        id={inputId}
        inputMode="numeric"
        placeholder="예: 100개 이하"
        value={draft}
        onChange={(event) => setDraft(event.target.value)}
        onBlur={commit}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            commit();
          }
        }}
      />
    </div>
  );
};
